import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';

import AuthService from '../services/authService';

// The Infor sign-in page sends the user back here with the access token in the URL fragment
class Callback extends Component {
    constructor(props) {
        super(props);

        this.state = {
            done: false,
            error: '',
        }
    }

    componentDidMount() {
        AuthService.completeLogin()
            .then(() => {
                // Remove the token from the address bar before leaving the page
                window.history.replaceState(null, '', window.location.pathname);

                if (this.props.onLogin) {
                    this.props.onLogin();
                }
                this.setState({ done: true });
            })
            .catch((error) => {
                window.history.replaceState(null, '', window.location.pathname);
                this.setState({ error: String(error) });
            });
    }

    render() {
        if (this.state.done) {
            return <Redirect to="/" />
        }

        if (this.state.error) {
            return (
                <div className="login-page">
                    <h2>PM Dashboard Login</h2>
                    <div className="login-result">{this.state.error}</div>
                    <Link to="/login">Back to login</Link>
                </div>
            )
        }

        return <p>Signing in...</p>
    }
}

export default Callback;
